<template>
  <div
    class="subprogram-nba-team-card"
    :style="`border-bottom: 4px solid ${teamCard.teamcolorPrimary}`"
    v-loading="loading"
  > 
    <!-- Image -->
    <div class="subprogram-nba-team-card__image" v-if="teamCard.teamImageUrl">
      <img :src="teamCard.teamImageUrl" ref="img" crossorigin="anonymous">
    </div>
    
    <!-- Title -->
    <div class="subprogram-nba-team-card__title"
      v-if="teamCard.teamName && teamConferencei18n && teamDivisioni18n"
    >
      <span class="subprogram-nba-team-card__title__team" v-text="teamCard.teamName + ' - '" />
      <span v-text="teamConferencei18n + ', '" />
      <span v-text="teamDivisioni18n" />
    </div>
    
    <!-- Description -->
    <div class="subprogram-nba-team-card__subtitle" v-if="teamCard.programName && teamCard.subprogramName">
      <span v-text="teamCard.programName + ' · '" />
      <span v-text="teamCard.subprogramName" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { i18n } from '@shared/i18n';
import { get } from 'lodash'; 

export default {
  name: 'app-subprogram-nba-team-card',
  props: {
    subpropertyId: {
      type: String,
      required: true
    },
    programId: {
      type: String,
      required: true
    },
    subprogramId: {
      type: String,
      required: true
    },
    teamId: {
      type: String,
      required: true
    },
  },

  computed: {
    ...mapGetters({
      program: 'subprogram/nba/teamCard/program',
      subprogram: 'subprogram/nba/teamCard/subprogram',
      team: 'subprogram/nba/teamCard/team',
      loading: 'subprogram/nba/teamCard/loading',
    }),
    teamConferencei18n() {
      if (this.teamCard.teamConference) {
        return i18n(`entities.subprogram.nba.conference.${this.teamCard.teamConference}.title`);
      }
      return null;
    },
    teamDivisioni18n() {
      if (this.teamCard.teamDivision) {
        return i18n(`entities.subprogram.nba.conference.${this.teamCard.teamConference}.division.${this.teamCard.teamDivision}`);
      }
      return null;
    },
    teamCard() {
      return {
        teamImageUrl: get(this, "team.logo[0].thumbPublicUrl", null),
        teamName: get(this, "team.name", null),
        teamcolorPrimary: get(this, "team.colorCodes[0]", '#fff'),
        teamConference: get(this, "team.groupsPhase.conference.name", null),
        teamDivision: get(this, "team.groupsPhase.division.name", null),
        programName: get(this, "program.name", null),
        subprogramName: get(this, "subprogram.name", null),
      }
    },
  },
 
  async mounted() {
      await this.doLoad({
        subpropertyId: this.subpropertyId,
        programId: this.programId,
        subprogramId: this.subprogramId,
        teamId: this.teamId
      });
  },

  methods: {
    ...mapActions({
      doLoad: 'subprogram/nba/teamCard/doLoad',
    }),
  },
}
  
</script>

<style lang="scss" scoped>
.subprogram-nba-team-card {
  height: 120px;
  display: grid;
  grid-template-areas: 'image title' 'image subtitle';
  grid-template-columns: 0fr 1fr;
  align-items: center;
  padding: 0 56px;
  &__image {
    grid-area: image;
    padding-right: 12px; 
    img {
      width: 60px;
    }
  }
  &__title {
    grid-area: title;
    align-self: flex-end;
    font-size: 24px;
    &__team {
      font-weight: bold;
    }
  }
  &__subtitle {
    grid-area: subtitle;
    color: #76787d;
    align-self: flex-start;
  }

}
</style>
